webpackJsonp([3],{

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/logo.5b9a7a21.png";

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    color:#FF00EA;\n    background: linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    background: -o-linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-family: \'Raleway\', sans-serif;\n    font-size: 3em;\n    text-align: center;  \n    margin: auto;\n    @media (max-width:320px) {\n      font-size: 2em;\n    }\n'], ['\n    color:#FF00EA;\n    background: linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    background: -o-linear-gradient(135deg, #FF00EA, #8F018F, #07E2FF, #5900FF);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-family: \'Raleway\', sans-serif;\n    font-size: 3em;\n    text-align: center;  \n    margin: auto;\n    @media (max-width:320px) {\n      font-size: 2em;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-family: \'Lato\', sans-serif;  \n  color: #FF00EA;\n  font-size: 3em;\n  font-weight: 300;\n  @media (max-width:320px) {\n      font-size: 1em;\n    }\n'], ['\n  font-family: \'Lato\', sans-serif;  \n  color: #FF00EA;\n  font-size: 3em;\n  font-weight: 300;\n  @media (max-width:320px) {\n      font-size: 1em;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: space-around;\n'], ['\n  display: flex;\n  flex-flow: column wrap;\n  justify-content: space-around;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: auto;\n  height: auto;\n  margin: auto;\n  text-align: center;\n  margin-top: 30vh;\n'], ['\n  width: auto;\n  height: auto;\n  margin: auto;\n  text-align: center;\n  margin-top: 30vh;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(21);

var _styledComponents = __webpack_require__(45);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _logo = __webpack_require__(293);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HomeTitle = _styledComponents2.default.h1(_templateObject);

var HomeSubTitle = _styledComponents2.default.h2(_templateObject2);

var CenterContainer = _styledComponents2.default.div(_templateObject3);

var CenterContent = _styledComponents2.default.div(_templateObject4);

var styles = {
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  links: {
    fontSize: "1.5em"
  },

  container: {
    textAlign: 'center',
    backgroundColor: '#150a1c'
  },
  h1: {},
  link: {
    textDecoration: 'none',
    color: ' #108db8',
    fontWeight: 'bold',
    margin: '5px'
  }
};
exports.default = (0, _reactStatic.withSiteData)(function () {
  return _react2.default.createElement(
    CenterContainer,
    null,
    _react2.default.createElement(
      CenterContent,
      null,
      _react2.default.createElement(
        HomeTitle,
        { className: 'aligner-item', style: styles.h1 },
        'ROSEANNA MCFARLANE'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        HomeSubTitle,
        { className: 'aligner-item' },
        'web developer'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.links },
        _react2.default.createElement(
          _reactStatic.Link,
          { style: styles.link, to: '/about' },
          'About'
        ),
        _react2.default.createElement(
          _reactStatic.Link,
          { style: styles.link, to: '/blog' },
          'Blog'
        ),
        _react2.default.createElement(
          _reactStatic.Link,
          { style: styles.link, to: '/projects' },
          'Projects'
        )
      )
    )
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Home.44574be3.js